
import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../contexts/AppContext';
import { Rol } from '../types';

interface SidebarProps {
  isOpen: boolean;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}

type NavItem = {
  name: string;
  screen: string;
  roles: Rol[];
  icon: React.ReactNode; // SVG inline (24x24)
};

// Iconos inline (Heroicons-style outline) para no agregar dependencias.
const I = {
  rayo: <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>,
  calendar: <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>,
  users: <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 014-4h4a4 4 0 014 4v2h-3M16 7a4 4 0 11-8 0 4 4 0 018 0z"/></svg>,
  box: <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/></svg>,
  cash: <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M5 6h14a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2zM7 15h.01M11 15h2"/></svg>,
  debt: <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8V6m0 12v-2m9-4a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>,
  chart: <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/></svg>,
  star: <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.196-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118L2.098 10.1c-.783-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"/></svg>,
  award: <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/></svg>,
  cog: <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065zM15 12a3 3 0 11-6 0 3 3 0 016 0z"/></svg>,
};

const Sidebar: React.FC<SidebarProps> = ({ isOpen, isCollapsed, onToggleCollapse }) => {
  const { user, club, activeScreen, setActiveScreen, logout } = useContext(AppContext);

  const navItems: NavItem[] = [
    { name: 'Cobro Rápido',     screen: 'dashboard',     roles: [Rol.ADMIN, Rol.CAJERO],                  icon: I.rayo },
    { name: 'Turnos y Canchas', screen: 'turnos',        roles: [Rol.ADMIN, Rol.CAJERO, Rol.VIEWER],      icon: I.calendar },
    { name: 'Socios',           screen: 'socios',        roles: [Rol.ADMIN, Rol.CAJERO, Rol.VIEWER],      icon: I.users },
    { name: 'Productos',        screen: 'productos',     roles: [Rol.ADMIN, Rol.VIEWER],                  icon: I.box },
    { name: 'Caja',             screen: 'caja',          roles: [Rol.ADMIN, Rol.CAJERO],                  icon: I.cash },
    { name: 'Deudas',           screen: 'deudas',        roles: [Rol.ADMIN, Rol.CAJERO, Rol.VIEWER],      icon: I.debt },
    { name: 'Reportes',         screen: 'reportes',      roles: [Rol.ADMIN, Rol.VIEWER],                  icon: I.chart },
    { name: 'Usuarios',         screen: 'usuarios',      roles: [Rol.ADMIN],                              icon: I.users },
    { name: 'Mi Suscripción',   screen: 'suscripcion',   roles: [Rol.ADMIN],                              icon: I.star },
    { name: 'Reglas de Puntos', screen: 'reglas',        roles: [Rol.ADMIN],                              icon: I.award },
    { name: 'Configuración',    screen: 'configuracion', roles: [Rol.ADMIN],                              icon: I.cog },
  ];

  const handleLogout = async () => { await logout(); };

  // Ancho: en mobile siempre w-64 (oculto/visible vía translate). En desktop,
  // colapsa a w-16. Cuando el sidebar está cerrado (mobile) usamos w-64 igualmente.
  const desktopWidth = isCollapsed ? 'md:w-16' : 'md:w-64';

  return (
    <aside
      className={`bg-gray-800 text-white w-64 ${desktopWidth} flex-shrink-0 flex flex-col h-screen
                  fixed md:relative inset-y-0 left-0 z-40
                  transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0
                  transition-all duration-200 ease-in-out`}
    >
      {/* HEADER: logo + toggle */}
      <div className="p-4 border-b border-gray-700 flex items-center justify-between gap-2">
        <div className={`flex items-center gap-2 min-w-0 ${isCollapsed ? 'md:hidden' : ''}`}>
          <img src={club?.logo_url || "/logo-2.png"} alt="Tu Club" className="h-8 flex-shrink-0" />
          <p className="text-sm text-gray-400 truncate">{club?.nombre || 'Club'}</p>
        </div>
        {/* Botón colapsar (solo desktop) */}
        <button
          onClick={onToggleCollapse}
          className="hidden md:flex items-center justify-center w-8 h-8 rounded hover:bg-gray-700 text-gray-300 flex-shrink-0"
          title={isCollapsed ? 'Expandir menú' : 'Colapsar menú'}
          aria-label={isCollapsed ? 'Expandir menú' : 'Colapsar menú'}
        >
          <svg className={`w-5 h-5 transform transition-transform ${isCollapsed ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
      </div>

      {/* NAV: scrollable si no entran todos los items */}
      <nav className="flex-1 min-h-0 overflow-y-auto px-2 py-3 space-y-1">
        {navItems.map(item =>
          user && item.roles.includes(user.rol) && (
            <a
              key={item.screen}
              href="#"
              onClick={(e) => { e.preventDefault(); setActiveScreen(item.screen as any); }}
              title={isCollapsed ? item.name : ''}
              className={`flex items-center gap-3 px-3 py-2 rounded-md transition-colors ${
                activeScreen === item.screen ? 'bg-blue-600 text-white' : 'hover:bg-gray-700'
              } ${isCollapsed ? 'md:justify-center md:px-2' : ''}`}
            >
              {item.icon}
              <span className={`${isCollapsed ? 'md:hidden' : ''} truncate`}>{item.name}</span>
            </a>
          )
        )}
      </nav>

      {/* FOOTER: info usuario + acciones */}
      <div className="p-3 border-t border-gray-700 flex-shrink-0">
        <div className={`${isCollapsed ? 'md:hidden' : ''} mb-2`}>
          <p className="text-sm truncate">Usuario: <strong>{user?.nombre}</strong></p>
          <p className="text-xs text-gray-400">Rol: {user?.rol}</p>
        </div>
        <div className="space-y-2">
          <button
            onClick={() => setActiveScreen('perfil')}
            title={isCollapsed ? 'Editar perfil' : ''}
            className={`w-full bg-green-600 hover:bg-green-700 text-white py-2 px-3 rounded-md text-sm flex items-center justify-center gap-2`}
          >
            <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"/></svg>
            <span className={isCollapsed ? 'md:hidden' : ''}>Editar perfil</span>
          </button>
          <button
            onClick={handleLogout}
            title={isCollapsed ? 'Cerrar sesión' : ''}
            className="w-full bg-red-600 hover:bg-red-700 text-white py-2 px-3 rounded-md text-sm flex items-center justify-center gap-2"
          >
            <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/></svg>
            <span className={isCollapsed ? 'md:hidden' : ''}>Cerrar Sesión</span>
          </button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
